// frontend/src/pages/Register.jsx
import React, { useState } from "react";
import { register, login, getMe } from "../services/authService";
import { useNavigate } from "react-router-dom";
import {
  Container, Box, Typography,
  TextField, Button
} from "@mui/material";          // ← Select 関連は不要

const Register = () => {
  const [email, setEmail]       = useState("");
  const [fullName, setFullName] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage]   = useState("");
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      // ① いつも student で登録
      await register(email, password, fullName, "student");

      // ② 自動ログイン
      const { access_token } = await login(email, password);
      localStorage.setItem("token", access_token);

      // ③ 自動遷移（role は student なので固定）
      navigate("/student/home");
    } catch (err) {
      setMessage(err.response?.data?.detail || err.message);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4, p: 3, border: "1px solid #ccc", borderRadius: 2 }}>
        <Typography variant="h5">Register</Typography>

        <form onSubmit={handleRegister}>
          <TextField
            label="Email" type="email" fullWidth required margin="normal"
            value={email} onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Full Name" fullWidth margin="normal"
            value={fullName} onChange={(e) => setFullName(e.target.value)}
          />
          <TextField
            label="Password" type="password" fullWidth required margin="normal"
            value={password} onChange={(e) => setPassword(e.target.value)}
          />

          {/* ロール選択 UI は削除 */}

          <Button type="submit" variant="contained" sx={{ mt: 2 }}>
            Register
          </Button>
        </form>

        {message && (
          <Typography color="error" sx={{ mt: 2 }}>{message}</Typography>
        )}
      </Box>
    </Container>
  );
};

export default Register;